<template>
  <v-navigation-drawer
    app
    clipped
    right
    class="drawer"
    hide-overlay
    :value="open"
    @input="handleNavChange"
  >
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.name"
        :to="item.path"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

export default {
  name: 'AppNavBar',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    handleNavChange (state) {
      this.$emit('navChanged', state)
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  margin-top: 56px;
}
</style>
